export default "__VITE_ASSET__BoSIwUe8__"